import { useRegisterBackOwner } from "@/components/contexts/backNavigationContext";
import { useBackNavigation } from "@hooks/backNavigation/useBackNavigation";
import * as subheaderAnalytics from "@/screens/subheader/subheader.analytics";
import { ChevronLeftIcon } from "@/screens/subheader/subheaderIcons";

import styles from "./AppBackButton.module.scss";

/**
 * App back control (renders nothing in a browser or on a root page). While shown it
 * owns back for the page, hiding the automatic back bar unless `ownsBack` is false.
 *
 * @param {"bar"|"row"|"link"} [variant] bar: dark subheader; row: light search row; link: chevron + destination name.
 */
const AppBackButton = ({
  variant = "bar",
  analytics,
  ownsBack = true,
  ref,
}) => {
  const { goBack, showBack, targetLabel } = useBackNavigation();
  useRegisterBackOwner(ownsBack && showBack);

  if (!showBack) {
    return null;
  }

  const onClick = () => {
    subheaderAnalytics.backClick(analytics);
    goBack();
  };

  return (
    <button
      ref={ref}
      type="button"
      className={`${styles.back} ${styles[variant]}`}
      aria-label={targetLabel ? `Back to ${targetLabel}` : "Back"}
      onClick={onClick}
    >
      <ChevronLeftIcon size={variant === "link" ? 18 : 24} />
      {variant === "link" && (
        <span className={styles.label}>{targetLabel ?? "Back"}</span>
      )}
    </button>
  );
};

export default AppBackButton;
